import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';

const api = '/api/';

@Injectable({
  providedIn: 'root'
})
export class FilterResource {
  public constructor(private httpClient: HttpClient) {
  }

  public getFilters(mode: string, subset): Observable<any> {
    // api can't handle empty subset value, so we need to remove it here.
    const params = new URLSearchParams(
      omitBy({
        elasticEntiteit: mode,
        elasticEntiteitSubset: subset
      },
      isEmpty)
    );
    return this.httpClient.get(`${api}filters?${params}`);
  }
}
